import { Card } from "@/components/ui/card";

export type SourceRef = {
  call?: string;
  timestamp?: string;
  note?: string;
};

export function SourceRefsFooter({ refs, title = "From the weekly calls" }: { refs: any; title?: string }) {
  const list: SourceRef[] = Array.isArray(refs) ? refs : [];
  if (!list.length) return null;
  return (
    <Card className="p-4 md:p-6">
      <h3 className="text-sm font-serif font-semibold mb-3 text-muted-foreground uppercase tracking-wide">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {list.map((r, i) => (
          <div key={i} className="rounded-md border bg-muted/40 px-3 py-2 text-xs md:text-sm">
            <div className="font-medium">
              Call {r.call || "-"}{r.timestamp ? ` @ ${r.timestamp}` : ""}
            </div>
            {r.note && <div className="text-muted-foreground mt-0.5">{r.note}</div>}
          </div>
        ))}
      </div>
    </Card>
  );
}
